import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { getEditorUrl } from 'page-lib/utils/urls';
import useContentId from '../../hooks/useContentId';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MABNotStarted = () => {
  const contentId = useContentId();
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.mabNotStarted.body"
      }), /*#__PURE__*/_jsx(Button, {
        href: getEditorUrl(contentId),
        use: "primary",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.mabNotStarted.button"
        })
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "automated-testing",
      width: 200
    }),
    secondaryContentWidth: 200,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.mabNotStarted.title"
    })
  });
};
export default MABNotStarted;